/* eslint-disable */
import Vue from 'vue';

import { propsDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import HotelPageModel from '@/js/desktop/components/hotel/model/HotelPageModel';

import firstPaymentDefinitionService from '@/js/common/Domain/Service/firstPaymentDefinition';
import getTourProductFirstPaymentDefinitions from '@/js/common/Domain/Service/hotelSearch/services/getTourProductFirstPaymentDefinitions';
import PartialPaymentHotelBannerView from '@/js/desktop/components/partialPayment/partialPaymentHotelBanner/PartialPaymentHotelBanner';

import SimilarHotels from '@widgets/similarHotels/SimilarHotels.vue';
import { FsaRegistry } from '@entities/fsaRegistry';

import CashbackHotelCardBanner from '@/js/desktop/components/cashbackHotelCardBanner/cashbackHotelCardBanner';
import TourSearchView from './tourSearch/TourSearch';
import MapHotelsSearchView from './MapHotelsSearch/MapHotelsSearch';
import PartialPaymentTooltipView from './pageTopBlock/partialPaymentTooltip/PartialPaymentTooltip';

@propsDecorator({
    subview: {
        comments: null,
        popovers: null,
        tourSearch: null,
    },
    events: {
        'click .allReviewsLink': 'gotoAllReviews',
        'click .reviewsCount': 'gotoAllReviews',
        'click .viewMapLink': 'gotoMap',
        'click .hotelDetails__about-more': 'gotoHotelDescription',
        'click .gallery-wrapper_minPriceButton': 'gotoSearchResults',
    },
    bindings: {
        '.hotelSerpContainer__tab-content.tab-content-tours': "classes:{'active': equal(activeTab, 'tours')}",
        '.hotelSerpContainer__tab-content.tab-content-hotels': "classes:{'active': equal(activeTab, 'hotels')}",
        '.criteria-block': 'html:htmlTourSearchCriteria',

        '.js-wrap-for-subscribeBannerTemplate': 'toggle:all(minPriceBySearchDates, not(subscribed))',

        '.gallery-wrapper_minPriceTours': "toggle:all(equal(activeTab, 'tours'), minPriceBySearchDates)",
        '.gallery-wrapper_minPriceStatic': "toggle:not(all(equal(activeTab, 'tours'), minPriceBySearchDates))",
        '.gallery-wrapper_minPriceToursValue': 'text:formatNumber(minPriceBySearchDates)',
        '.js-epoxy-oilTax-value': 'text:formatNumber(minPriceOilTaxBySearchDates)',
        '.js-cashbackHotelPageBanner': 'toggle:showHotelCashbackBanner',
    },
    bindingFilters: {
        equal(modelField, value) {
            return modelField === value;
        },
        formatNumber(number) {
            number = +number;
            if (_.isNumber(number)) {
                return number.formatNumber();
            }
        },
    },
})

export default class HotelPageView extends Backbone.Epoxy.View {
    initialize(options) {
        const self = this;
        this.dataLayerAnalytics = options.dataLayerAnalytics;

        this.addValidateMethods();
        this.initModel();
        this.initTourSearch();
        this.initModelEvents(options);

        this.initSubViews();
        this.initDOMEvent();
        $('#buyTourDialog').correctPopupPosition();

        /* scroll to reviews if url param*/
        if (document.location.hash.indexOf('toReviews=true') !== -1) {
            setTimeout(() => {
                self.gotoAllReviews();
            }, 3000);
        }
    }

    addValidateMethods() {
        $.validator.addMethod('custom_phone', function (value, element) {
            const replacedValue = value.replace(/-/g, '').replace(/\)/g, '').replace(/\(/g, '').replace(/ /g, '')
                .substr(1);
            return this.optional(element) || replacedValue.length >= 10;
        }, 'Указан неверный телефон');
    }

    initModel() {
        this.model = new HotelPageModel();
    }

    initTourSearch() {
        this.subview.tourSearch = new TourSearchView({
            el: '.hotelSerpContainer__tab-content#tab-content-tours',
            parentView: this,
        });
    }

    initModelEvents(options) {
        this.model.set('tourSearchModel', this.subview.tourSearch.model);
        this.model.set('hotelInfo', options.hotelInfo ? options.hotelInfo : null);

        this.model
            .get('tourSearchModel')
            .on('change:syncTourProducts', this.syncTourProductsChanged.bind(this));

        this.model
            .get('tourSearchModel')
            .on('change:syncTourProducts', this.updateBannerData.bind(this));
    }

    initVueComponents() {
        this.initSimilarHotels();
        this.initFsaRegistry();
    }

    initFsaRegistry() {
        const fsaRegistryInfo = window.appConfig?.hotelInfo?.fsaRegistry;

        if (!fsaRegistryInfo?.number) {
            return;
        }

        new Vue({
            name: 'FsaRegistry',
            render: (h) => h(FsaRegistry, {
                props: {
                    fsaRegistryInfo,
                }
            }),
        }).$mount('.fsa-registry-js');
    }

    initSimilarHotels() {
        new Vue({
            name: 'SimilarHotels',
            render: (h) => h(SimilarHotels, {
                props: {
                    hotelInfo: window.appConfig.hotelInfo,
                },
                on: {
                    'hide-skeletons': () => {
                        const skeletonEl = document.querySelector('.similar-hotel__skeleton-wrap');

                        if (skeletonEl) {
                            skeletonEl.style.display = 'none';
                        }
                    },
                },
            }),
        }).$mount('.similar-hotels__element');
    }

    initSubViews() {
        this.initVueComponents();

        this.subview.mapHotelsSearch = new MapHotelsSearchView({
            el: '.hotelsMap',
            parentView: this,
        });

        new PartialPaymentTooltipView({
            model: this.model.get('tourSearchModel'),
            el: '.price-block',
        });

        this.initCashbackHotelPageBanner();
    }

    initCashbackHotelPageBanner() {
        new CashbackHotelCardBanner({
            el: $('.js-cashbackHotelPageBanner'),
            addType: 'append',
            tailPosition: 'bottom-center',
            width: 'full',
            rounded: 'top',
        });
    }

    syncTourProductsChanged() {
        const syncTourProducts = this?.syncTourProducts;

        if (syncTourProducts?.length > 0) {
            this.toggleLessPlacesLabel((syncTourProducts.at(0)?.get('tour')?.get('lessPlaces')));
        }
    }

    setActiveTab(e) {
        this.model.set('activeTab', $(e.currentTarget).data('id'));
    }

    toggleLessPlacesLabel(status) {
        const $lessPlacesLabel = this.$('.hotelLabelLessPlaces');

        if (status) {
            $lessPlacesLabel.show();
        } else {
            $lessPlacesLabel.hide();
        }
    }

    gotoSearchResults() {
        $('html,body').animate({
            scrollTop: $('.hotelContent').offset().top - 100,
        }, 500);
    }

    gotoAllReviews() {
        $('html, body').animate({scrollTop: $('.reviewsTabs').offset().top - 100}, 500);
    }

    gotoMap(e) {
        e.preventDefault();
        e.stopPropagation();
        $('html, body').animate({scrollTop: $('.hotelsMap').offset().top - 100}, 500);
        if (!$('#showMapContainer:visible').length) {
            $('#openMap').click();
        }
    }

    updateBannerData() {
        const tourProducts = this.syncTourProducts;
        const firstPaymentDefinitions = getTourProductFirstPaymentDefinitions(tourProducts);

        firstPaymentDefinitionService.setData(firstPaymentDefinitions);

        if (firstPaymentDefinitions?.length) {
            this.renderPartialPaymentBanner();
        }
    }

    gotoHotelDescription(e) {
        e.preventDefault();
        e.stopPropagation();
        $('html, body').animate({scrollTop: $('.aboutHotel').offset().top - 100}, 500);
    }

    initDOMEvent() {
        const self = this;
        $('.js-open-date-picker').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            $('.formDropdownWithCalendar.tour-duration .formInputPlace').click();
        });
        $('.js-open-meal-filter').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            $('.serpFilterItem.meal .formInputLabel').click();
        });
    }

    renderPartialPaymentBanner() {
        const foundTourProduct = this.syncTourProducts
            .find((tourProduct) => !!tourProduct.get('firstPaymentDefinition').firstPaymentPart);

        if (foundTourProduct) {
            const $partialPaymentBannerContainer = $('.partialPaymentBanner_forHotelPage');

            this.partialPaymentBannerView = new PartialPaymentHotelBannerView({
                el: $partialPaymentBannerContainer,
                countryName: this.model.get('hotelInfo')?.countryName || '',
                tourProducts: this.syncTourProducts,
            });
        }
    }

    get syncTourProducts() {
        return this.model
            ?.get('tourSearchModel')
            ?.get('syncTourProducts') || [];
    }
}
